module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"description":"We\u0027re sorry but the service is currently unavailable. Please reload or try again later.","reload":"@:labels.reload","title":"Service Unavailable"},"fr":{"description":"Nous sommes désolés mais le service est actuellement indisponible. Veuillez recharger ou réessayer plus tard.","reload":"@:labels.reload","title":"Service indisponible"}}')
  delete Component.options._Ctor
}
